/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {HISTORY_EVENT_ICON_BY_ASSET} from '../maps/constants';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Stop Icon component.
 */
export const InputEventIcon = (props: IconProps) => {
  const {iconSize}   = useIconDLS(props);
  const {inputEvent} = HISTORY_EVENT_ICON_BY_ASSET;

  return (
    <ThemeIconProvider name='InputEventIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 16 16' fill='none' xmlns="http://www.w3.org/2000/svg">
        <path fillRule='evenodd' clipRule='evenodd' d='M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM5.23713 3.34374C5.59957 3.14322 6.05594 3.27449 6.25646 3.63693C6.45698 3.99937 6.32571 4.45574 5.96326 4.65626C5.34751 4.99692 4.83903 5.48691 4.48674 6.07407C4.13457 6.66103 3.9502 7.32532 3.9502 8C3.9502 8.67469 4.13457 9.33902 4.48674 9.92597C4.83902 10.5131 5.34749 11.0031 5.96326 11.3437C6.32571 11.5443 6.45698 12.0006 6.25646 12.3631C6.05594 12.7255 5.59957 12.8568 5.23713 12.6563C4.39452 12.1901 3.69108 11.5154 3.20049 10.6977C2.70979 9.87985 2.4502 8.94913 2.4502 8C2.4502 7.05086 2.70979 6.12018 3.20049 5.30234C3.69107 4.48469 4.39451 3.80991 5.23713 3.34374ZM10.7631 3.34374C10.4006 3.14322 9.94425 3.27449 9.74374 3.63693C9.54322 3.99937 9.67449 4.45574 10.0369 4.65626C10.6527 4.99692 11.1612 5.48691 11.5135 6.07407C11.8656 6.66103 12.05 7.32532 12.05 8C12.05 8.67469 11.8656 9.33902 11.5135 9.92597C11.1612 10.5131 10.6527 11.0031 10.0369 11.3437C9.67449 11.5443 9.54322 12.0006 9.74374 12.3631C9.94425 12.7255 10.4006 12.8568 10.7631 12.6563C11.6057 12.1901 12.3091 11.5154 12.7997 10.6977C13.2904 9.87985 13.55 8.94913 13.55 8C13.55 7.05086 13.2904 6.12018 12.7997 5.30234C12.3091 4.48469 11.6057 3.80991 10.7631 3.34374ZM10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6C9.10457 6 10 6.89543 10 8Z'
          fill={inputEvent.color} />
      </svg>
    )} />
  );
};
